// extracted by mini-css-extract-plugin
module.exports = {"camas":"Modal_camas__27FIO","margenArriba05rem":"Modal_margenArriba05rem__2UHnI"};